(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["album-art-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('album-slider')) {
    customElements.define('album-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        if (!this.track) return;

        this._update = this.updateArrows.bind(this);
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByStep(1));
        this.track.addEventListener('scroll', this._update, { passive: true });
        window.addEventListener('resize', this._update, { passive: true });
        this.updateArrows();
      }

      get step() {
        const item = this.track.querySelector('.album-slider__item');
        if (!item) return this.track.clientWidth * 0.8;
        const styles = getComputedStyle(this.track);
        const gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      scrollByStep(dir) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: this.step * dir, behavior: reduce ? 'auto' : 'smooth' });
      }

      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth - 1;
        const x = this.track.scrollLeft;
        if (this.prevBtn) this.prevBtn.disabled = x <= 0;
        if (this.nextBtn) this.nextBtn.disabled = x >= max;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
